export const ua = {
  menu: {
    main: "Головна",
    sneakers: "Кросівки",
    cart: "Кошик",
  },

  sneakersSection: {
    headerTitle: "ВСІ КРОСІВКИ",
    headerSubTitle:
      "Купуйте новинки таких відомих імен, як Air Jordan, Nike, New Balance і Yeezy, а також найновіші колаборації таких брендів, як Vans, Reebok, Converse, ASICS тощо.",
    filterSneakers: {
      filterTitle: "Фільтр",
      model: "Модель",
      sizes: "Розміри",
      brand: "Бренд",
      price: "Ціна",
      year: "Рік",
    },
    apply: "застосовувати",
    from: "від",
    to: "до",
    filterErrors: {
      yearBiggerLower: "Рік 'Від' не може бути більше ніж 'До'",
      yearBigger: "Рік не може бути більше ніж 2023",
      yearLower: "Рік не може бути менше ніж 1994",
      priceBiggerLower: "Ціна 'Від' не може бути більше ніж 'До'",
      priceBigger: "Ціна не може бути більше ніж 6000",
      priceLower: "Ціна не може бути менше ніж 10",
    },
    sneakersResult: {
      resultsTitle: "Результати",
      show: "Показувати",
      sort: {
        sotrBy: "Сортувати:",
        relevance: "Актуальність",
        low: "Спочатку дешеві",
        high: "Спочатку дорогі",
        newest: "Новинки",
        trending: "Популярність",
      },
      emptyText: {
        notFound: "Вибачте, результатів не знайдено",
        checkFilters:
          "Будь ласка, перевірте фільтри або перегляньте іншу модель кросівок",
      },
    },
  },

  mainSection: {
    shopNow: "здійснити покупку",
    newReleases: {
      title: "НОВИНКИ",
      button: "КУПИТИ НОВИНКИ",
    },
    staffPicks: {
      title: "зараз у тренді",
      button: "КУПИТИ кросівки",
    },
    about: {
      titleStore: "Магазини",
      titleHistory: "Наша історія",
      textStore:
        "З трьома роздрібними місцями в Нью -Йорку, Лос -Анджелесі та Майамі, Flight Club залишається головним джерелом для всіх кросівок.",
      textHistory:
        "Понад десятиліття Flight Club змінив ландшафт роздрібної торгівлі.Переводячи кожну торгову марку на ринку, Flight Club перетворився з єдиного місця для кросівок, до культурного центру для любителів кросівок та новачків.Від Air Jordans до Nike до Adidas та багато іншого, у нас це все.",
    },
  },

  cartSection: {
    title: "Ваш кошик з замовленням",
    total: "РАЗОМ",
    buttonOrder: "Оформити замовлення",
    size: "Розмір",
    emptyCart: "Кошик порожній",
  },

  favoriteSection: {
    title: "Обрані кросівки",
    emptyFavorites: "Ви ще не додали обраних кросівок",
  },

  sneakerPage: {
    size: "Виберіть розмір",
    buy: "Купити за",
    goToCart: "Перейти до кошику",
    addedToCart: "Кросівки додані до кошика",
    delivery: {
      title: "Доставка та повернення",
      cancelations: "Скасування",
      cancelationsDescription1:
        "Для кросівок ви можете скасувати своє замовлення протягом 3 годин після його розміщення або до того, як його підтвердить продавець - залежно від того, що з’явиться першим.Якщо 3 години минуло, коли ви розмістили замовлення та/або продавець вже підтвердив замовлення, то замовлення неможливо скасувати.Якщо не відбулося, ви можете спочатку скасувати своє замовлення, отримавши доступ до нього за допомогою 'Відстежувати моє замовлення' або 'Мій рахунок', натиснувши 'Скасувати замовлення' та дотримуючись інструкцій.",
      cancelationsDescription2:
        "Якщо ви перевірили як гостя, вам потрібно буде створити обліковий запис Flight Club.",
      delivery: "Доставка",
      deliveryDescription1:
        "Швидкість доставки та обробки змінюється залежно від варіантів ціноутворення.Наступні оцінки доставки стосуються лише суміжних США та виключення поставок до побокних ящиків та військових баз.Усі часи доставки - це оцінки і не гарантуються.Відвантаження можуть впливати на затримки, пов'язані з погодою, обмеження перевізників або інші події поза нашим контролем.",
      deliveryDescription2:
        "Замовлення 'найнижчої ціни' можуть першим доставити до польотного клубу для перевірки і, як правило, потрібно 7-10 робочих днів (M-F, виключаючи канікули), щоб дістатися до вас.Зазвичай це займе 3-5 робочих днів (M-F, за винятком канікул) для предмета 'найшвидшого для вас', замовленим до 14:00 ET зі стандартною доставкою, що потрібно доставити.",
      deliveryDescription3:
        "Орієнтовні терміни доставки не застосовуються до міжнародних замовлень.Міжнародні клієнти несуть відповідальність за будь -які додаткові збори або податки після товару.",
      returns: "Повернення",
      returnsDescription1: "Усі продажі з Flight Club є остаточними.",
      returnsDescription2:
        "Якщо у вас є якісь питання чи проблеми щодо розміру або стану певного товару на нашому сайті, будь ласка, зв'яжіться з нами перед покупкою.",
    },
    recommended: "РЕКОМЕНДОВАНО ДЛЯ ВАС",
  },

  placeOrderSection: {
    orderConfirmed: {
      title: "Замовлення підтверджено",
      hint: "зачекайте відповіді нашого менеджера електронною поштою",
      button: "Повернутися на головну",
    },
    title: "ІНФОРМАЦІЯ ПРО ЗАМОВЛЕННЯ",
    email: "Ваша електронна адреса",
    name: "Повне ім'я",
    address: "Адреса доставки",
    city: "Місто",
    zip: "Поштовий індекс",
    telephone: "Телефон",
    emailPlaceholrer: "електронна пошта",
    namePlaceholrer: "ім'я",
    addressPlaceholrer: "адреса",
    cityPlaceholrer: "місто",
    zipPlaceholrer: "індекс",
    telephonePlaceholrer: "номер",
    makeOrderBTN: "Підтвердити замовлення",
  },

  inputErrors: {
    enterEmail: "введіть адресу електронної пошти",
    incorrect: "неправильна адреса електронної пошти",
    enterFullName: "введіть ваше повне ім'я",
    enterFirstAndLastName: "введіть прізвище та прізвище",
    enterAddress: "введіть свою адресу",
    enterCity: "введіть своє місто",
    enterZip: "введіть поштовий індекс",
    incorrectZip: "неправильний поштовий індекс",
    wrongNumberDigits: "неправильна кількість цифр",
    incorrectTelephone: "неправильний номер телефону",
  },
};
